import { forwardRef } from "react";
import Select, { Props as SelectProps } from "react-select";
import colors from "../../assets/theme/base/colors";
import styles from "./styles";

interface FaiSelectProps extends SelectProps {
	size?: "small" | "medium" | "large";
	error?: boolean;
	success?: boolean;
	isRequired?: boolean;
}

const FaiSelect = forwardRef<any, FaiSelectProps>(
	(
		{
			size = "medium", // Set default value here
			error = false, // Set default value here
			success = false, // Set default value here
			...rest
		},
		ref
	) => {
		const { light } = colors;

		return (
			<Select
				{...rest}
				ref={ref}
				// @ts-ignore
				styles={{
					...styles(size, error, success),
					control: (base: any) => ({
						...base,
						flexWrap: "nowrap",
						borderRadius: ".5rem",
					}),
					singleValue: (base: any) => ({
						...base,
						width: "100%",
						fontSize: "16px !important",
					}),
					placeholder: (base: any) => ({
						...base,
						color: `#d3d3d3 !important`,
						fontWeight: "400 !important",
						fontSize: "16px !important",
					}),
					multiValue: (base: any) => ({
						...base,
						backgroundColor: "#f9e9da",
					}),
				}}
				theme={(theme) => ({
					...theme,
					colors: {
						...theme.colors,
						primary25: light.main,
						primary: light.main,
					},
				})}
			/>
		);
	}
);

export default FaiSelect;
